window.addEventListener("DOMContentLoaded", function () {
  // product card内容 统一高度
  const containers = [".bf-25-wet-showcase1", ".bf-25-wet-showcase2"];
  function equalizeContainerHeights(containerSelector) {
    const parent_obj = $(containerSelector);
    function equalizeHeights(selector) {
      const elements = parent_obj.find(selector);
      let maxHeight = 0;
      elements.css("height", "auto");
      elements.each(function() {
        const currentHeight = $(this).outerHeight();
        maxHeight = Math.max(maxHeight, currentHeight);
      });
      if (maxHeight > 0) {
        elements.css("height", maxHeight + "px");
      }
    }
    equalizeHeights(".product_reviews");
    equalizeHeights(".title-box");
    equalizeHeights(".subtitle-box");
  }

  $(document).ready(function() {
    containers.forEach(container => equalizeContainerHeights(container));
  });

  let resizeTimer;
  $(window).on("resize", function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      containers.forEach(container => equalizeContainerHeights(container));
    }, 250);
  });

  
  // discount 按钮点击跳转
  $(".valentine-2026-discount .valentine-2026-discount-shop-button").on("click", function () {
    const offsetTop = $(".deep-clean-wet").offset().top;
    const gap = 80;

    $("html, body").animate({ scrollTop: offsetTop + gap }, 400);
  });


  // 礼品卡模块，点击按钮下载模版
  async function downloadPdf(url, filename) {
    const res = await fetch(url);
    const blob = await res.blob();

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }

  $(".valentine-2026-gift-card .item-cell-1 .item-2 .valentine-2026-gift-card-button").on("click", function () {
    const files = [
      "https://cdn.shopify.com/s/files/1/0553/1320/3405/files/Valentine_2026_Card_Templates.zip?v=1769422629",
    ];

    files.forEach((url, index) => {
      downloadPdf(url, "Valentine 2026 Card Templates");
    });
  });

});
